import { View } from 'react-native';

import {
  combineMappers,
  mapElementProps,
  renderChildren,
} from '../Html';

export default combineMappers(mapElementProps, renderChildren)(View);



// WEBPACK FOOTER //
// ./node_modules/@shoutem/ui/html/elements/Virtual.js